import { render, staticRenderFns } from "./SuporteTabelaContratos.vue?vue&type=template&id=4dd13cf1"
import script from "./SuporteTabelaContratos.vue?vue&type=script&lang=ts"
export * from "./SuporteTabelaContratos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports